import { z } from 'zod';
export const healthResponseSchema = z.object({
    status: z.enum(['ok', 'error']),
    database: z.enum(['ok', 'error']),
    version: z.string(),
});
//# sourceMappingURL=health.js.map